import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: { width: 'auto' as const },
    clientSearchButton: {
        padding: '.25rem .5rem',
        marginRight: '1rem',
        borderRadius: '16px',
        cursor: 'pointer' as const,
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHover ||
                '#bec4cf'
        }
    },
    searchIcon: {
        height: '20px',
        width: '20px',
        marginRight: '.75rem'
    },
    searchButtonLabel: {
        color: theme?.app.applicationColors.fontDetailColor ||
            '#4A4C50'
    },
    searchBarContainer: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#cfcfcf'}`,
        borderRadius: '12px',
        paddingLeft: '.5rem'
    },
    searchBarInput: {
        border: 'none',
        borderRight: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#cfcfcf'}`,
        width: '12rem',
        padding: '.25rem'
    },
    searchBarClose: {
        height: '24px',
        width: '24px',
        marginLeft: '.25rem',
        marginRight: '.35rem'
    },
    foundUsersContainer: {
        position: 'absolute' as const,
        top: '54px',
        right: 0,
        width: '27vw',
        minHeight: '64px',
        height: 'auto' as const,
        maxHeight: '90vh',
        backgroundColor: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#cfcfcf'}`,
        borderRadius: '4px',
        zIndex: 100
    },
    divider: { height: '2px' },
    trimMessage: {
        position: 'absolute' as const,
        zIndex: 100,
        backgroundColor: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF'
    },
    searchMessage: { margin: 'auto' as const },
    messageText: { padding: '.25rem 1rem' },
    clientList: {
        position: 'relative' as const,
        overflowY: 'auto' as const
    },
    listMessagePadding: { marginTop: '50px' }
});